module.exports = __webpack_public_path__ + "img/bear.2729dfa0.png";